import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { GetSelectList } from 'src/app/_Models/getSelectList';
import { SystemService } from 'src/app/_Services/_Shared/system.service';
import { environment } from 'src/assets/environments/environment';
import Swal from 'sweetalert2';

import { GetDeptList } from 'src/app/_Models/getDeptList';
import { FileExchange } from 'src/app/_SharedFunctions/fileExcange';
import { IPost_DeptModel } from 'src/app/_Models/AD/ADSYS/ADSYS0501/IPost_DeptModel';
import { IAttachment } from '../../../_Models/AD/ADSYS/ADSYS0501/IPost_DeptModel';
import { AccountService } from 'src/app/_Services/_Shared/account.service';
import { auth } from 'src/app/_Models/auth';

@Component({
    selector: 'app-ADSYS0501',
    templateUrl: './ADSYS0501.component.html',
    styleUrls: ['./ADSYS0501.component.css']
})
export class ADSYS0501Component implements OnInit {
    baseUrl = environment.apiUrl;
    user!: auth;
    modalRef?: BsModalRef;

    //人事單位(下拉清單)
    unitList: GetSelectList[] = [];
    //系所資料(下拉清單)
    deptList: GetDeptList[] = [];

    //查詢列表
    listData: IPost_DeptModel[] = [];

    //新增、修改、查詢詳細資料(資料模型)
    detailData: IPost_DeptModel = {
        Post_Id: '',
        Type_ID: '',
        Type_Name: '',
        Unit_Code: '',
        Unit_Name: '',
        Post_UnitName: '',
        Post_Subject: '',
        Post_Content: '',
        Post_Date: '',
        End_Date: '',
        Post_Object: 'A',
        Attachment: []
    };

    //查詢條件
    condition = {
        Type_ID: "",
        Type_Name: "",
        Unit_Code: "",
        Unit_Name: "",
        Post_UnitName: "",
        Post_Subject: "",
        Post_Date: "",
        End_Date: "",
        Post_Object: "A",
        Dept_No: "",
    };

    bsConfig = environment.bsDatePickerConfig;

    isInsert: boolean = false;
    isUpdate: boolean = false;


    isNewData = false;

    model: any;
    teacherList: any;
    UnitListLock: boolean = false;
    DeptListLock: boolean = false;
    fileExchange = new FileExchange();
    fileBase64 = '';
    fileName = '';
    Attachment: IAttachment[] = [];

    constructor(
        public accountService: AccountService,
        private http: HttpClient,
        private toastr: ToastrService,
        private localeService: BsLocaleService,
        private systemService: SystemService,
        private modalService: BsModalService,

    ) {
        this.accountService.currentUser$.subscribe(user => {

            if (user != null) {
                this.user = user;

            }
        });
    }

    //初始化
    ngOnInit(): void {
        this.localeService.use('zh-cn');

        this.getUnitList();
        this.getDeptList();
        this.conditionObjectOnchange();
        this.Search();
    }


    //視窗資料
    OpenDialog(template: TemplateRef<any>, i: number) {
        this.detailData = {
            Post_Id: null,
            Type_ID: '1',
            Type_Name: '',
            Unit_Code: '',
            Unit_Name: '',
            Post_UnitName: '',
            Post_Subject: '',
            Post_Content: '',
            Post_Date: '',
            End_Date: '',
            Post_Object: 'A',
            Attachment: []
        };

        this.isNewData = true;
        this.isInsert = true;

        let modalConfig = {
            backdrop: true,
            ignoreBackdropClick: true,
            class: 'modal-xl'
        };

        this.Attachment = [];

        if (i > -1) {
            this.isInsert = false;
            this.isUpdate = true;
        } else {
            this.isInsert = true;
            this.isUpdate = false;
        }

        if (this.isUpdate) {
            this.SearchDetail(i);
        }

        if (this.isInsert) {
            this.detailData.Post_UnitName = this.user.UnitName;
        }

        this.modalRef = this.modalService.show(template, modalConfig);

    }

    //取得學校單位
    getUnitList() {
        this.systemService.getUnitList('', '', '').subscribe(response => {
            if (response.Info == false) {
                return;
            }
            this.unitList = response;
        });
    }

    //取得系所
    getDeptList() {
        this.systemService.getDeptList('', '3', '', '', 'Y', '').subscribe(response => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.deptList = response;
        });
    }

    //公告對象(查詢)(下拉觸發事件)
    conditionObjectOnchange() {
        if (this.condition.Post_Object == "A") {
            //值為1時，系所及單位皆鎖定
            this.UnitListLock = true;
            this.DeptListLock = true;
        }
        if (this.condition.Post_Object == "T") {
            //值為2時，鎖定系所
            this.UnitListLock = false;
            this.DeptListLock = true;
        }
        if (this.condition.Post_Object == "S") {
            //值為3時，鎖定單位
            this.UnitListLock = true;
            this.DeptListLock = false;
        }
        this.condition.Dept_No = '';
        this.condition.Unit_Code = '';
    }

    //公告對象(新增、詳細資料)(下拉觸發事件)
    detailObjectOnchange() {
        if (this.detailData.Post_Object == "A") {
            this.UnitListLock = true;
            this.DeptListLock = true;
        }
        if (this.detailData.Post_Object == "T") {
            this.UnitListLock = false;
            this.DeptListLock = true;
        }
        if (this.detailData.Post_Object == "S") {
            this.UnitListLock = true;
            this.DeptListLock = false;
        }

        this.detailData.Unit_Code = '';
    }

    //查詢列表
    Search(): void {
        this.http.post<any>(this.baseUrl + "ACAD/SYS/ADSYS0501/Search", this.condition).subscribe((response) => {
            this.listData = response;

            if (this.listData.length == 0) {
                this.toastr.warning('查無資料');
            }
        });
    }

    //詳細資料
    SearchDetail(i: number): void {
        this.http.post<any>(this.baseUrl + "ACAD/SYS/ADSYS0501/Search_detail", this.listData[i]).subscribe((response) => {

            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }

            this.detailData = response;
            this.detailObjectOnchange();
        });
    }

    //新增、修改前檢查
    ValidationModify(): boolean {
        if (this.detailData.Post_Subject == '' || this.detailData.Post_Subject == null) {
            this.toastr.warning('請填寫主旨');
            return false;
        }

        if (this.detailData.Post_Content == '' || this.detailData.Post_Content == null) {
            this.toastr.warning('請填寫內容');
            return false;
        }

        if (this.detailData.Post_Date == '' || this.detailData.Post_Date == null) {
            this.toastr.warning('請填寫開始時間');
            return false;
        }

        if (this.detailData.End_Date == '' || this.detailData.End_Date == null) {
            this.toastr.warning('請填寫結束時間');
            return false;
        }

        if (this.detailData.Post_Object == '' || this.detailData.Post_Object == null) {
            this.toastr.warning('請填寫身分');
            return false;
        }

        return true;
    }

    //新增資料
    InsertPost(): void {

        if (this.ValidationModify() == false) {
            return;
        }

        this.detailData.Attachment = [];
        this.detailData.Attachment = this.Attachment;

        this.http.post<any>(this.baseUrl + "ACAD/SYS/ADSYS0501/insert", this.detailData).subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }

            this.toastr.success("新增成功");
            this.modalRef?.hide();
            this.Search();
        });

    }

    //修改儲存
    UpdatePost(): void {

        if (this.ValidationModify() == false) {
            return;
        }

        this.detailData.Attachment = [];
        this.detailData.Attachment = this.Attachment;


        this.http.post<any>(this.baseUrl + "ACAD/SYS/ADSYS0501/update", this.detailData).subscribe((response) => {
            if (response.Info == false) {
                this.toastr.warning(response.Message);
                return;
            }
            this.toastr.success("儲存成功");
            this.modalRef?.hide();
            this.Search();
        });

    }

    //刪除
    DeletePost(): void {

        Swal.fire({
            title: `確定刪除?`,
            confirmButtonText: '確定',
            showCancelButton: true,
            cancelButtonColor: 'red',
            cancelButtonText: '取消'
        }).then(result => {

            if (result.isConfirmed) {

                this.http.post<any>(this.baseUrl + "ACAD/SYS/ADSYS0501/delete", this.detailData).subscribe((response) => {

                    if (response.Info == false) {
                        this.toastr.warning(response.Message);
                        return;
                    }

                    this.toastr.success("刪除成功");
                    this.modalRef?.hide();
                    this.Search();
                })
            }
        })
    }

    //上傳
    async importData($event: any) {
        this.Attachment = [];
        let file = $event.target.files;
        if (file.length == 0) return;

        for (let i = 0; i < file.length; i++) {
            let fileBase64 = await this.fileExchange.FileToBase64String(file[i]);
            this.Attachment?.push({ FileName: file[i].name, Base64: fileBase64 });
        }

    }

    //下載
    Download(FileName: string, Base64String: string) {
        this.fileExchange.Base64StringToDownloadFile(FileName, Base64String);
    }

}
